import { Navigate } from "react-router-dom";
import { decryptFn } from "../shared/helperFunction";

const PublicRoute = ({ children }) => {
    const token = decryptFn(localStorage.getItem("accessToken"));
    return (!token ? children : <Navigate to="/dashboard" replace />)
};


export default PublicRoute;